import { useEffect, useState, useRef } from "react";
import "./CareTeam.css";
// import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";

const CareTeam = (props) => {
  // eslint-disable-next-line
  const [selectActive, setSelectActive] = useState(false);
  const [careTeamData, setCareTeamData] = useState([]);
  const [modalMainTherapist, setModalMainTherapist] = useState(false);
  const [currentTherIndx, setCurrentTherIndx] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [refCalled, setRfCalled] = useState(false);
  const selectRef = useRef([]);
  const { id } = useParams();
  const { program_id } = useParams();
  const navigate = useNavigate();

  const userBusinessID =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).business_id
      : -1;

  useEffect(() => {
    if (id > 0) {
      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        const userCareTeamData = {
          business_id: userBusinessID,
          userId: id,
        };
        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("userData")
        ).token;
        axios
          .post(window.ajaxLink + "cloud_programs/get-member-care-team-data", {
            userCareTeamData,
          })
          .then((res) => {
            if (res.data.responseData) {
              setCareTeamData(res.data.responseData);
              setIsLoaded(true);
              localStorage.setItem(
                "careTeamData",
                JSON.stringify(res.data.responseData)
              );
            }
          })
          .catch((error) => {
            console.error(error);
            if (error.response.data.responseCode === 417) {
              setIsLoaded(true);
            }
          });
      }
    }
    // eslint-disable-next-line
  }, [id]);

  const handleSelectedPermissions = (t, p) => {
    const ther = [...careTeamData];
    const perm = [...ther[t].permissions];
    perm[p].value = !perm[p].value;
    ther[t].selected = true;
    if (perm[p].key === "All Premissions" && perm[p].value) {
      perm.forEach((p) => {
        p.value = true;
        ther[t].modalOpened = false;
      });
      ther[t].selected = true;
    } else if (perm[p].key === "All Premissions" && !perm[p].value) {
      perm.forEach((p) => {
        p.value = false;
      });
      ther[t].selected = false;
    }

    setCareTeamData(ther);
  };

  const handleSaveCareList = () => {
    const careTeamSaveData = {
      id,
      program_id,
      careTeamData,
    };
    if (careTeamSaveData.careTeamData && localStorage.getItem("careTeamData")) {
      if (
        JSON.stringify(careTeamSaveData.careTeamData) !==
        localStorage.getItem("careTeamData")
      ) {
        axios.defaults.headers.common["Authorization"] = JSON.parse(
          localStorage.getItem("userData")
        ).token;
        axios
          .post(window.ajaxLink + "cloud_programs/save-patient-care-list", {
            careTeamSaveData,
          })
          .then((res) => {
            if (res.data.responseData) {
              navigate(`/patient-details/${id}/${program_id}`);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        navigate(`/patient-details/${id}/${program_id}`);
      }
    }
  };

  const handleSelectedTherapist = (i) => {
    const data = [...careTeamData];
    const perm = [...data[i].permissions];
    data[i].selected = !data[i].selected;
    if (data[i].slected === false) {
      perm.forEach((p) => {
        p.value = false;
      });
    }
    data[i].permissions = perm;
    setCareTeamData(data);
  };

  const handleMainTherapistChange = () => {
    const inx = currentTherIndx;
    const mainTher = [...careTeamData];
    const perm = [...mainTher[inx].permissions];
    for (let other of mainTher) {
      other.isMainTherapist = false;
    }
    mainTher[inx].isMainTherapist = !mainTher[inx].isMainTherapist;
    if (mainTher[inx].isMainTherapist) {
      mainTher[inx].selected = true;
      perm.forEach((p) => {
        p.value = true;
      });
    }
    setCareTeamData(mainTher);
    setModalMainTherapist(false);
  };

  const handleChangeMainTherapistModal = (i) => {
    setModalMainTherapist(true);
    setCurrentTherIndx(i);
  };

  const handleSelectedModal = (i) => {
    const data2 = [...careTeamData];
    for (var d of data2) {
      if (d !== data2[i]) d.modalOpened = false;
    }
    data2[i].modalOpened = !data2[i].modalOpened;
    setCareTeamData(data2);
  };
  useEffect(() => {
    handleCloseAll();
    // eslint-disable-next-line
  }, [refCalled]);

  function useOutsideSelect(ref) {
    useEffect(() => {
      let ter = refCalled;
      function handleClickOutside(event) {
        let i = 0;
        ref.current.forEach((c) => {
          if (!c.contains(event.target)) {
            i++;
          }
        });

        if (i === ref.current.length) {
          ter = !ter;
          setRfCalled(ter);
        }
      }
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideSelect(selectRef);

  const displaySelected = (i) => {
    const therapSelect = [...careTeamData];
    var selectedOptions = [];
    // eslint-disable-next-line
    therapSelect[i].permissions.map((sel) => {
      if (sel.value === true) {
        selectedOptions.push(sel.key);
      }
    });
    var optionsToDisplay = "";
    if (selectedOptions.length > 1) {
      optionsToDisplay = selectedOptions.join(", ");
    } else {
      optionsToDisplay = selectedOptions[0];
    }
    return optionsToDisplay;
  };

  const closeModalMainTherapist = () => {
    setModalMainTherapist(false);
  };

  const handleCloseAll = () => {
    const data3 = [...careTeamData];

    for (var d of data3) {
      d.modalOpened = false;
    }

    setCareTeamData(data3);
  };

  const cancelAddCareTeam = () => {
    navigate(`/patient-details/${id}/${program_id}`);
  };

  const scrollIntoView = (i) => {
    selectRef.current[i].scrollIntoView();
  };

  return (
    <>
      <Breadcrumbs id={id} program_id={program_id} />
      <div className="add_member_title_and_btn_holder">
        <div className="prog_det_title_hold" >
          <div className="prog_det_title" style={{padding: 0}}>Add Patient Care Team</div>
        </div>
      </div>
      <div style={{flex: 1}} className="add_member_tab_container">
        {/* <div className="add_member_tab_holder">
          <div className="programs_dash_top_options">
            <div className="programs_dash_contain_opts">
              <div className="programs_dash_option  p_d_option_selected">Care Team</div>
            </div>
          </div>
        </div> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "15px",
            flex: 1,
            flexWrap: 'wrap'
          }}
          className="add_member_btn_holder"
        >
          <div
            className="cancel_btn_add_member"
            style={{ margin: 0, textAlign: "center" }}
            onClick={cancelAddCareTeam}
          >
            Cancel
          </div>
          <div
            className="save_btn_add_member"
            style={{ margin: 0, textAlign: "center" }}
            onClick={handleSaveCareList}
          >
            Save Patient Care Team
          </div>
        </div>
      </div>
      {isLoaded ? (
        <div className="add_member_hold" style={{maxWidth: 'calc(100vw - 2rem - 2*(clamp(10px, 5vw, 24px)))', overflowX: 'auto'}}>
          {careTeamData && careTeamData.length > 0 ? (
            <div className="add_member_holder">
              <div className="programs_table">
                <div className="programs_cols">
                  <div className="programs_col_info team_select mr-3">
                    <div className="programs_col_name ">Select</div>
                  </div>
                  <div className="programs_col_info">
                    <div className="programs_col_name">Name</div>
                  </div>
                  <div className="programs_col_info">
                    <div className="programs_col_name">Role</div>
                  </div>
                  <div className="programs_col_info">
                    <div className="programs_col_name">Main Therapist</div>
                  </div>
                  <div className="programs_col_info">
                    <div className="programs_col_name">Permissions</div>
                  </div>
                </div>
                <div className="tbl_content_hold pb-4">
                  {careTeamData &&
                    careTeamData.map((item, i) => (
                      <div
                        key={i}
                        className="programs_tbl_content current_patient_mark"
                        style={{ margin: "8px 0" }}
                      >
                        <div className="programs_tbl_row client-list_row exr_coll_card add_team_resize">
                          <div
                            className="programs_tbl_col_contain team_select team_select_flex my-0"
                            onClick={() =>
                              item.isMainTherapist
                                ? ""
                                : handleSelectedTherapist(i)
                            }
                          >
                            <div className="exr_coll_half left_exr_coll">
                              <div
                                className={
                                  "exr_coll_check" +
                                  (item.selected && !item.isMainTherapist
                                    ? " exr_coll_checked"
                                    : item.isMainTherapist
                                    ? " exr_coll_checked_main_therapist"
                                    : "")
                                }
                              ></div>
                            </div>
                          </div>
                          <div className="programs_tbl_col_contain my-0">
                            <div className="programs_tbl_col">
                              {item.username}
                            </div>
                          </div>
                          <div className="programs_tbl_col_contain my-0">
                            <div className="programs_tbl_col">{item.role}</div>
                          </div>
                          {
                            <div className="programs_tbl_col_contain my-0">
                              <div className="exr_coll_half left_exr_coll">
                                <div
                                  className={
                                    "exr_coll_check" +
                                    (item.isMainTherapist
                                      ? " exr_coll_checked exr_coll_checked_main_therapist"
                                      : "")
                                  }
                                  // onClick={() => handleMainTherapistChange(i)}
                                  onClick={() =>
                                    handleChangeMainTherapistModal(i)
                                  }
                                ></div>
                              </div>
                            </div>
                          }
                          <div
                            className="programs_tbl_col_contain my-0"
                            ref={(ref) => (selectRef.current[i] = ref)}
                            onClick={() => scrollIntoView(i)}
                          >
                            <div
                              className={
                                "multi_main additional_position" +
                                (selectActive ? " show_select_options" : "")
                              }
                              onClick={() =>
                                item.isMainTherapist
                                  ? ""
                                  : handleSelectedModal(i)
                              }
                            >
                              <div className="select_values_contain">
                                <div
                                  className={"select_placeholder sp_act"}
                                ></div>
                                <div className="multi_value">
                                  {displaySelected(i)}
                                </div>
                              </div>
                              <div className={"select_main_arrow"}></div>
                            </div>
                            <div
                              className={
                                "options_hold" +
                                (item.modalOpened
                                  ? " multi_oh_enabled additional_width"
                                  : " oh_disabled")
                              }
                            >
                              {item.permissions.map((option, k) => (
                                <div
                                  key={k}
                                  className={
                                    "multi_oh_option" +
                                    (option.value ? " multi_green" : "")
                                  }
                                  onClick={() =>
                                    handleSelectedPermissions(i, k)
                                  }
                                >
                                  <div
                                    className={
                                      "multi_check" +
                                      (option.value ? " multi_checked" : "")
                                    }
                                  ></div>
                                  {option.key}
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* <div className="programs_tbl_col_contain my-0">
                        <div className="programs_tbl_col">{moment(item.dateAdded).format("MM/DD/YYYY")}</div>
                      </div> */}
                        </div>
                      </div>
                    ))}
                </div>
                {modalMainTherapist && (
                  <div className="dlt_wrapper" style={{ position: "fixed" }}>
                    <div className="dbl_place_on_page">
                      <div className="dlt_surround ">
                        <div className="dlt_title">Change Main Therapist</div>
                        <div className="dlt_description">
                          <p>
                            Are you sure you want to change patient main
                            therapist?
                          </p>
                        </div>
                        <div className="dlt_exit_btm">
                          <div
                            className="dlt_exit_btn dlt_eb_first"
                            onClick={closeModalMainTherapist}
                          >
                            Cancel
                          </div>
                          <div
                            className="dlt_exit_btn dlt_eb_scnd"
                            onClick={handleMainTherapistChange}
                          >
                            Yes
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="pt_list_empty">
              There is no therapists with permissions.
            </div>
          )}
        </div>
      ) : (
        <div className="p_load loader_care_team"></div>
      )}
    </>
  );
};

export default CareTeam;
